import { all } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { saga as actorsSaga } from '@savgroup-front-common/core/domains/actors';
import { saga as attachmentsSaga } from '@savgroup-front-common/core/domains/attachments';
import { saga as carriersSaga } from '@savgroup-front-common/core/domains/carriers';
import { saga as claimsSaga } from '@savgroup-front-common/core/domains/claims';
import { saga as fileUploadSaga } from '@savgroup-front-common/core/domains/fileUpload';
import { saga as i18nSaga } from '@savgroup-front-common/core/domains/i18n';
import { saga as sellerConfigurationSaga } from '@savgroup-front-common/core/domains/sellerConfiguration';
import { sellerSaga } from '@savgroup-front-common/core/domains/sellers';
import { storeSaga } from '@savgroup-front-common/core/domains/store';
import { technicalInterventionsSaga } from '@savgroup-front-common/core/domains/technicalInterventions';
import { saga as workflowSaga } from '@savgroup-front-common/core/domains/workflow';

import { saga as actionSaga } from './actions';
import { claimSaga } from './Claim/saga';
import { customerSaga } from './Customer/saga';
import { fileTrackingPageSaga } from './FileTrackingPage/fileTrackingView';
import ordersSaga from './Orders/saga';
import { saga as ownerSaga } from './owner';

export default function* rootSaga() {
  try {
    yield all([
      i18nSaga(),
      workflowSaga(),
      actionSaga(),
      carriersSaga(),
      claimsSaga(),
      ownerSaga(),
      sellerConfigurationSaga(),
      fileUploadSaga(),
      storeSaga(),
      attachmentsSaga(),
      technicalInterventionsSaga(),
      ordersSaga(),
      actorsSaga(),
      sellerSaga(),

      claimSaga(),
      customerSaga(),
      fileTrackingPageSaga(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
